// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholder {
	padding: 2px 2px;
	outline-offset: -2px;
	line-height: 1em;
	margin: 0 1px;
}

.placeholder::selection {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./src/ckeditor5-footnote/theme/placeholder.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,oBAAoB;CACpB,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,aAAa;AACd","sourcesContent":[".placeholder {\n\tpadding: 2px 2px;\n\toutline-offset: -2px;\n\tline-height: 1em;\n\tmargin: 0 1px;\n}\n\n.placeholder::selection {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
